import axios from 'axios'
import './interceptor'
import DeviceDetector from 'device-detector-js'
import CONFIG from '../config'

class ApiClass {
    constructor() {
        this.request = axios.create({
            baseURL: CONFIG.API_ROOT,
        })
        this.request.defaults.timeout = 30000
        this.request.defaults.headers.common['Authorization'] =
            localStorage.getItem('id_token') !== null ||
            localStorage.getItem('id_token') !== undefined
                ? localStorage.getItem('id_token')
                : 'dfgh'
    }

    interimResult = (roll_no) => {
        let data = { roll_number: roll_no }
        let config = {
            method: 'post',
            url: CONFIG.interimResult,
            headers: {
                'Content-Type': 'application/json',
            },
            data: data,
        }
        return axios(config)
    }

    init = () => {
        let config = {
            method: 'get',
            url: CONFIG.init,
            headers: {
                'Content-Type': 'application/json',
            },
        }
        return axios(config)
    }

    startNewTest = (data, deviceInfo) => {
        data.browserUuid = localStorage.getItem('browser-uuid')
        let config = {
            method: 'post',
            url: CONFIG.startNewTest,
            headers: {
                'Content-Type': 'application/json',
                deviceSource: deviceInfo.deviceSource,
                deviceName: deviceInfo.deviceName,
                deviceId: deviceInfo.deviceId,
                deviceToken: deviceInfo.deviceToken,
            },
            data,
        }
        return axios(config)
    }

    resumeTest = (userTestId, deviceInfo) => {
        const browserUuid = localStorage.getItem('browser-uuid')
        let config = {
            method: 'get',
            url: `${CONFIG.resumeTest}/${userTestId}?browserUuid=${browserUuid}`,
            headers: {
                'Content-Type': 'application/json',
                deviceSource: deviceInfo.deviceSource,
                deviceName: deviceInfo.deviceName,
                deviceId: deviceInfo.deviceId,
                deviceToken: deviceInfo.deviceToken,
            },
        }
        return axios(config)
    }

    getSyllabus = () => {
        return this.request.get(`syllabus/${CONFIG.TEST_ID}`)
    }

    getInstructionDataByShortCode = (shortCode) => {
        const config = {
            method: 'get',
            url: `${CONFIG.testInstructionsByShortCode}/${shortCode}`,
        }
        return axios(config)
    }

    getTestQuestionAnswerData = (testKey, testId) => {
        const tp_preview_token = sessionStorage.getItem('tp_preview_token')
        const is_mock = JSON.parse(sessionStorage.getItem('is_mock'))

        let url
        if (tp_preview_token) {
            url = `${CONFIG.previewQuestionsData}/${testId}`
        } else if (is_mock) {
            url = `${CONFIG.mockQuestionsData}/${testId}`
        } else {
            url = `${CONFIG.questionsData}/${testKey}`
        }

        const config = {
            method: 'get',
            url,
            // On test preview the backend also validates the HttpOnly CMS_AUTH
            // cookie (Domain=.aakash.ac.in) to confirm the signed-in staff user
            // may view this test, so the request must carry credentials. Gated
            // on CONFIG.previewWithCredentials until the endpoint stops
            // answering credentialed requests with Allow-Origin: *.
            withCredentials:
                Boolean(tp_preview_token) && Boolean(CONFIG.previewWithCredentials),
        }
        return axios(config)
    }

    postQuestionAnswerMock = (
        questionData,
        sections,
        deviceInfo,
        test_short_code,
        userTestId,
    ) => {
        const browserUuid = localStorage.getItem('browser-uuid')
        let data = JSON.stringify({
            userQuestion: questionData,
            sections: sections,
            testShortCode: test_short_code,
        })
        let config = {
            method: 'post',
            url: CONFIG.mockTestDataSubmit,
            headers: {
                'Content-Type': 'application/json',
                'x-browser-uuid': `${userTestId}_${browserUuid}`,
                deviceSource: deviceInfo.deviceSource,
                deviceName: deviceInfo.deviceName,
                deviceId: deviceInfo.deviceId,
            },
            data: data,
        }
        return axios(config)
    }

    postQuestionAnswer = (
        userTestId,
        setId,
        answerData,
        isFinalSubmit,
        testId,
        deviceInfo,
    ) => {
        const browserUuid = localStorage.getItem('browser-uuid')
        let data = JSON.stringify({
            userTestId: userTestId,
            setId: setId,
            submitSource: 'Web',
            finalSubmit: isFinalSubmit,
            answers: answerData,
            testId: testId,
        })
        let config = {
            method: 'post',
            url: CONFIG.testDataSubmit,
            headers: {
                'Content-Type': 'application/json',
                'x-browser-uuid': `${userTestId}_${browserUuid}`,
                deviceSource: deviceInfo.deviceSource,
                deviceName: deviceInfo.deviceName,
                deviceId: deviceInfo.deviceId,
            },
            data: data,
        }
        return axios(config)
    }
    logActivityType = (props, actionType) => {
        const deviceDetector = new DeviceDetector()
        const device = deviceDetector.parse(navigator.userAgent)
        let deviceInfo = {
            deviceSource: device.device?.type,
            deviceName: device.os?.name,
            deviceId: props.deviceId,
        }
        let data = {
            packageId: props.instructions.testData.packageId,
            testId: props.instructions.testData.id,
            questionId: null,
            userTestId: props.testStatus?.testStatus?.data?.userTestId,
            timeSpend: 1,
            attempted: 0,
            markedForReview: 0,
            isCorrect: 0,
            answer: null,
            lod: 'E',
            activityType: actionType,
            rollNo: props.testStatus?.testStatus?.data?.testRollNo,
            testAttemptNo: props.queryparam.test_attempt,
        }
        const browserUuid = localStorage.getItem('browser-uuid')

        let config = {
            method: 'post',
            url: CONFIG.updateSingleQuestion,
            headers: {
                'Content-Type': 'application/json',
                'x-browser-uuid': `${props.testStatus?.testStatus?.data?.userTestId}_${browserUuid}`,
                deviceSource: deviceInfo.deviceSource,
                deviceName: deviceInfo.deviceName,
                deviceId: deviceInfo.deviceId,
            },
            data: data,
        }
        return axios(config)
    }

    postTabSwitchFullScreenExitLogs = ({
        userTestId,
        testId,
        testAttemptNo,
        rollNo,
        questionId,
        deviceId,
        activityType,
    }) => {
        const deviceDetector = new DeviceDetector()
        const device = deviceDetector.parse(navigator.userAgent)
        let deviceInfo = {
            deviceSource: device.device?.type,
            deviceName: device.os?.name,
            deviceId: deviceId,
        }

        const browserUuid = localStorage.getItem('browser-uuid')

        let config = {
            method: 'post',
            url: CONFIG.getTabSwitchCount,
            headers: {
                'Content-Type': 'application/json',
                'x-browser-uuid': `${userTestId}_${browserUuid}`,
                deviceSource: deviceInfo.deviceSource,
                deviceName: deviceInfo.deviceName,
                deviceId: deviceInfo.deviceId,
            },
            data: {
                userTestId,
                testId,
                testAttemptNo,
                rollNo,
                questionId,
                activityType,
            },
        }

        return axios(config)
    }

    getTabSwitchCount = ({ userTestId, testAttemptNo, deviceId }) => {
        const deviceDetector = new DeviceDetector()
        const device = deviceDetector.parse(navigator.userAgent)
        let deviceInfo = {
            deviceSource: device.device?.type || 'unknown',
            deviceName: device.os?.name || 'unknown',
            deviceId: deviceId,
        }
        const browserUuid = localStorage.getItem('browser-uuid')

        let config = {
            method: 'get',
            url: `${CONFIG.getTabSwitchCount}?userTestId=${userTestId}&testAttemptNo=${testAttemptNo}`,
            headers: {
                'Content-Type': 'application/json',
                'x-browser-uuid': `${userTestId}_${browserUuid}`,
                deviceSource: deviceInfo.deviceSource,
                deviceName: deviceInfo.deviceName,
                deviceId: deviceInfo.deviceId,
            },
        }

        return axios(config)
    }

    updateSingleQuestion = (
        userId,
        courseId,
        packageId,
        userTestId,
        questionid,
        timeSpent,
        isAnswered,
        isMarkiedForReview,
        answerbyUser,
        lod,
        roll_no,
        testId,
        testAttemptNo,
        deviceInfo,
        actionType,
    ) => {
        let data = {
            packageId: packageId,
            testId: testId,
            questionId: questionid,
            userTestId: userTestId,
            timeSpend: timeSpent,
            attempted: isAnswered,
            markedForReview: isMarkiedForReview,
            isCorrect: 1,
            answer: answerbyUser,
            lod: lod,
            activityType: actionType,
            rollNo: roll_no,
            testAttemptNo: testAttemptNo,
        }

        const browserUuid = localStorage.getItem('browser-uuid')

        let config = {
            method: 'post',
            url: CONFIG.updateSingleQuestion,
            headers: {
                'Content-Type': 'application/json',
                'x-browser-uuid': `${userTestId}_${browserUuid}`,
                deviceSource: deviceInfo.deviceSource,
                deviceName: deviceInfo.deviceName,
                deviceId: deviceInfo.deviceId,
            },
            data: data,
        }

        return axios(config)
    }

    submitTest = (props, isFinalSubmit) => {
        const isMock = JSON.parse(sessionStorage.getItem('is_mock'))
        let answerData = [...props.testData.questionset]
        let testId = props.instructions.testData.id
        let data = []
        const deviceDetector = new DeviceDetector()
        const device = deviceDetector.parse(navigator.userAgent)
        let deviceInfo = {
            deviceSource: device.device?.type,
            deviceName: device.os?.name,
            deviceId: props.deviceId,
        }
        const sections = []

        for (let i = 0; i < answerData.length; i++) {
            sections.push(answerData[i].subject.en)
            for (let j = 0; j < answerData[i].questionList.length; j++) {
                if (
                    !Array.isArray(
                        answerData[i].questionList[j].question.answerbyUser,
                    )
                )
                    answerData[i].questionList[j].question.answerbyUser = [
                        answerData[i].questionList[j].question.answerbyUser,
                    ]
                let submittedAns = answerData[i].questionList[
                    j
                ].question.answerbyUser.filter((item) => item != '')
                let correctAnswer = []
                answerData[i].questionList[j].question.english_answer.choices &&
                    answerData[i].questionList[
                        j
                    ].question.english_answer.choices?.map((item) => {
                        if (item.is_answer) correctAnswer.push(item.choiceId)
                    })
                if (
                    answerData[i].questionList[j].question.questionType === 'MATRIX'
                ) {
                    correctAnswer =
                        answerData[i].questionList[j].question.english_answer.answer
                }
                if (
                    answerData[i].questionList[j].question.questionType === 'SAN' ||
                    answerData[i].questionList[j].question.questionType === 'SAT'
                ) {
                    correctAnswer.push(
                        answerData[i].questionList[j].question.english_answer.answer,
                    )
                }
                let questionState
                if (answerData[i].questionList[j]?.question?.isAnswered && isMock) {
                    if (
                        submittedAns?.sort()?.toString() ===
                        correctAnswer?.sort()?.toString()
                    )
                        questionState = 'Correct'
                    else questionState = 'Incorrect'
                } else {
                    questionState = 'Not Attempted'
                }
                data.push(
                    this.getQuestionItemData({
                        props,
                        i,
                        j,
                        answerData,
                        testId,
                        submittedAns,
                        questionState,
                        correctAnswer,
                        isMock,
                    }),
                )
            }
        }
        if (isMock) {
            return this.postQuestionAnswerMock(
                data,
                sections,
                deviceInfo,
                props.queryparam.test_short_code,
                props.testStatus?.testStatus?.data?.userTestId,
            )
        } else {
            return this.postQuestionAnswer(
                props.testStatus?.testStatus?.data?.userTestId,
                1,
                data,
                isFinalSubmit,
                testId,
                deviceInfo,
            )
        }
    }

    getQuestionItemData = ({
        props,
        i,
        j,
        answerData,
        testId,
        submittedAns,
        questionState,
        correctAnswer,
        isMock,
    }) => {
        let item = {}
        if (isMock) {
            item['testId'] = testId
            item['questionId'] = answerData[i].questionList[j].question.questionid
            item['userTestId'] = props?.testStatus?.testStatus?.data?.userTestId
            item['timeSpend'] = 0
            item['marks'] = answerData[i].questionList[j].question.marks
            item['isAttempted'] = answerData[i].questionList[j].question.isAnswered
            item['isCorrect'] =
                submittedAns?.sort()?.toString() ===
                correctAnswer?.sort()?.toString()
                    ? true
                    : false
            item['section'] = answerData[i].subject.en
            item['answer'] = JSON.stringify(submittedAns)
            item['testType'] = props.queryparam.test_type
            item['lod'] = answerData[i].questionList[j].question.lod
            item['activityType'] = null
            item['questionState'] = questionState
            item['rollNo'] = props.queryparam.roll_no
        } else {
            item['questionId'] = answerData[i].questionList[j].question.questionid
            item['submittedAnswer'] = JSON.stringify(submittedAns)
        }
        return item
    }

    updateQuestion = (props, d, quesId, actionType) => {
        const deviceDetector = new DeviceDetector()
        const device = deviceDetector.parse(navigator.userAgent)
        let deviceInfo = {
            deviceSource: device.device?.type,
            deviceName: device.os?.name,
            deviceId: props.deviceId,
        }
        let qId = quesId

        let userId = props?.testStatus?.testStatus?.data?.userId,
            packageId = props.instructions.testData.packageId,
            userTestId = props?.testStatus?.testStatus?.data?.userTestId,
            testId = props.instructions.testData.id,
            testAttemptNo = props.queryparam.test_attempt
        let roll_no = props.testStatus?.testStatus?.data?.testRollNo,
            courseId = 34,
            timeSpent
        for (let i = 0; i < d.length; i++) {
            if (d[i].subject === props.subject) {
                for (let j = 0; j < d[i].questionList.length; j++) {
                    if (d[i].questionList[j].question.questionid === qId) {
                        if (
                            !Array.isArray(
                                d[i].questionList[j].question.answerbyUser,
                            )
                        )
                            d[i].questionList[j].question.answerbyUser = [
                                d[i].questionList[j].question.answerbyUser,
                            ]
                        let submittedAns = d[i].questionList[
                            j
                        ].question.answerbyUser.filter(
                            (item) =>
                                item != '' &&
                                item != 'null' &&
                                item != undefined &&
                                item != null,
                        )
                        timeSpent = d[i].questionList[j].question.timeSpent
                        return this.updateSingleQuestion(
                            userId,
                            courseId,
                            packageId,
                            userTestId,
                            qId,
                            timeSpent,
                            d[i].questionList[j].question.isAnswered ? 1 : 0,
                            d[i].questionList[j].question.isMarkedForReview ? 1 : 0,
                            JSON.stringify(submittedAns),
                            d[i].questionList[j].question.lod,
                            roll_no,
                            testId,
                            testAttemptNo,
                            deviceInfo,
                            actionType,
                        )
                    }
                }
            }
        }
    }

    getoAuthToken = () => {
        let url = CONFIG.getTokenForResultApi
        var data = new FormData()
        data.append('grant_type', 'password')
        data.append('client_id', 'b58c8fe9-55bd-4b03-81d7-e836c6f7b5e8')
        data.append('username', 'app_apiadmin')
        data.append('password', 'app@4r5t6yapi%1q2w')

        const config = { headers: { 'Content-Type': 'multipart/form-data' } }
        return axios.post(url, data, config)
    }

    getResultData = (token, roll_no) => {
        let data = JSON.stringify({ roll_number: roll_no })

        let config = {
            method: 'post',
            url: CONFIG.getResultData,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: data,
        }

        return axios(config)
    }

    getAnalyticsData = (userTestId) => {
        const browserUuid = localStorage.getItem('browser-uuid')
        let config = {
            method: 'get',
            url: `${CONFIG.getAnalyticsData}?userTestId=${userTestId}`,
            headers: {
                'Content-Type': 'application/json',
                'x-browser-uuid': `${userTestId}_${browserUuid}`,
            },
        }
        return axios(config)
    }

    getTestState = (userTestId) => {
        const browserUuid = localStorage.getItem('browser-uuid')
        let config = {
            method: 'get',
            headers: {
                'x-browser-uuid': `${userTestId}_${browserUuid}`,
            },
            url: `${CONFIG.getAttemptedQuestions}/${userTestId}`,
        }
        return axios(config)
    }

    getTestStatus = (test_short_code, testRollNo, param, test_attempt) => {
        let data = JSON.stringify([
            {
                testShortCode: test_short_code,
                testRollNo: testRollNo,
                resetCount: test_attempt,
            },
        ])
        let config = {
            method: 'get',
            url: `${CONFIG.getTestStatus}${param}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: data,
        }
        return axios(config)
    }
    getQuestionImageBaseUrl = () => {
        return CONFIG.question_image_url
    }

    verifyCaptcha = (response) => {
        let data = JSON.stringify({ token: response })

        let config = {
            method: 'post',
            url: `${CONFIG.captcha}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: data,
        }
        return axios(config)
    }

    validateOTP = (pwd) => {
        let config = {
            method: 'post',
            url: `${CONFIG.validateOTP}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: { password: pwd },
        }
        return axios(config)
    }

    getDashboardURL = () => {
        return CONFIG.dashboard
    }
}

export default ApiClass
